import React, { useState } from "react";
import {
    CButton,
    CCard,
    CCardBody,
    CCol,
    CRow,
    CBadge,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CDropdown,
    CDropdownToggle,
    CDropdownMenu,
    CDropdownItem,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CFormLabel,
    CModalFooter,
    CFormInput,
    CCardHeader,
    CCardTitle,
    CCardText,
    CInputGroup,
    CInputGroupText,
} from "@coreui/react-pro";
import CIcon from "@coreui/icons-react";
import { cilOptions, cilPencil, cilTrash, cilPlus, cilSearch } from "@coreui/icons";
import MedusaSearchInput from "../../components/medusa/MedusaSearchInput";

interface Category {
    id: string;
    name: string;
    slug: string;
    productsCount: number;
    status: "active" | "inactive";
}

const mockCategories: Category[] = [
    { id: "#1", name: "Comida Rápida", slug: "comida-rapida", productsCount: 24, status: "active" },
    { id: "#2", name: "Bebidas & Licores", slug: "bebidas-licores", productsCount: 15, status: "active" },
    { id: "#3", name: "Postres & Helados", slug: "postres-helados", productsCount: 8, status: "inactive" },
];

export const CategoriesList: React.FC = () => {
    const [modalVisible, setModalVisible] = useState(false);
    const [search, setSearch] = useState("");
    // const [categories] = useState<Category[]>([
    //     { id: 1, name: 'Comida Rápida', slug: 'comida-rapida', products_count: 24, status: 'active' },
    //     { id: 2, name: 'Bebidas & Licores', slug: 'bebidas-licores', products_count: 15, status: 'active' },
    //     { id: 3, name: 'Postres & Helados', slug: 'postres-helados', products_count: 8, status: 'inactive' },
    // ]);
    return (
        <div className="categories-container">
            {/* HEADER DE LA SECCIÓN */}
            {/* <div className="d-flex align-items-center justify-content-between mb-4">
             
                <div>
                    <h4 className="fw-semibold text-body mb-1">Categorías de Productos</h4>
                    <p className="text-body-secondary small mb-0">
                        Gestiona la clasificación de tu menú y catálogo de productos
                    </p>
                </div> */}


            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h3 className="fw-bold text-dark mb-1">Categorías de Productos</h3>
                    <p className="text-muted small mb-0">Gestiona la clasificación de tu menú y catálogo de productos</p>
                </div>

                <div className="d-flex  justify-content-between">
                    <div className="position-relative mx-2">
                        <CFormInput
                            placeholder="Buscar"
                            value={search} onChange={(e) => setSearch(e.target.value)}
                            className="ps-5"
                        />
                        <CIcon
                            icon={cilSearch}
                            className="position-absolute text-muted"
                            style={{ left: '14px', top: '50%', transform: 'translateY(-50%)' }}
                        />
                    </div>
                    <CButton
                        color="light"
                        className="d-flex align-items-center gap-2 px-3 py-2 fw-medium border-0 shadow-sm text-body bg-body-tertiary"
                        style={{ borderRadius: "8px" }}
                        onClick={() => setModalVisible(true)}
                    >
                        <CIcon icon={cilPlus} size="sm" />
                        <span>Nueva Categoría</span>
                    </CButton>
                </div>
            </div>

            {/* TABLA DE CATEGORÍAS */}
            <CCard className="border-0 shadow-sm rounded-3 bg-body-tertiary">
                {/* <CCardHeader className="py-3 fs-5 fw-semibold" color="light">
                    Categorias
                </CCardHeader>
                <CCardHeader className="py-3 fs-5 fw-semibold" color="light">
                    <div className="d-flex align-items-center justify-content-between">

                 
                        <div className="position-relative">
                            <CFormInput
                                placeholder="Buscar"
                                value={search} onChange={(e) => setSearch(e.target.value)}
                                className="ps-5"
                            />
                            <CIcon
                                icon={cilSearch}
                                className="position-absolute text-muted"
                                style={{ left: '14px', top: '50%', transform: 'translateY(-50%)' }}
                            />
                        </div>

                        <CButton
                            color="light"
                            className="d-flex align-items-center gap-2 px-3 py-2 fw-medium border-0 shadow-sm text-body bg-body-tertiary"
                            style={{ borderRadius: "8px" }}
                            onClick={() => setModalVisible(true)}
                        >
                            <CIcon icon={cilPlus} size="sm" />
                            <span>Nueva Categoría</span>
                        </CButton>
                    </div>
                </CCardHeader> */}
                <CCardBody className="p-0">
                    <CTable responsive align="middle" className="mb-0 border-0">
                        <CTableHead className="bg-body-secondary text-body-secondary border-bottom border-secondary border-opacity-10 " color="light">
                            <CTableRow>
                                <CTableHeaderCell className="ps-4 py-3 fw-medium small">ID</CTableHeaderCell>
                                <CTableHeaderCell className="py-3 fw-medium small">Nombre</CTableHeaderCell>
                                <CTableHeaderCell className="py-3 fw-medium small">Slug</CTableHeaderCell>
                                <CTableHeaderCell className="py-3 fw-medium small">Productos Asociados</CTableHeaderCell>
                                <CTableHeaderCell className="py-3 fw-medium small">Estado</CTableHeaderCell>
                                <CTableHeaderCell className="pe-4 py-3 text-end fw-medium small">Acciones</CTableHeaderCell>
                            </CTableRow>
                        </CTableHead>

                        <CTableBody>
                            {mockCategories.map((cat) => (
                                <CTableRow key={cat.id} className="border-bottom border-secondary border-opacity-10">
                                    <CTableDataCell className="ps-4 text-body-secondary fw-medium small">{cat.id}</CTableDataCell>
                                    <CTableDataCell className="fw-semibold text-body">{cat.name}</CTableDataCell>
                                    <CTableDataCell className="text-body-secondary font-monospace small">{cat.slug}</CTableDataCell>
                                    <CTableDataCell className="text-body">{cat.productsCount} productos</CTableDataCell>
                                    <CTableDataCell>
                                        {cat.status === "active" ? (
                                            <CBadge
                                                className="fw-medium px-2 py-1"
                                                style={{
                                                    backgroundColor: "rgba(16, 185, 129, 0.12)",
                                                    color: "#10B981",
                                                    borderRadius: "6px",
                                                }}
                                            >
                                                • Activa
                                            </CBadge>
                                        ) : (
                                            <CBadge
                                                className="fw-medium px-2 py-1 text-body-secondary"
                                                style={{
                                                    backgroundColor: "rgba(148, 163, 184, 0.12)",
                                                    borderRadius: "6px",
                                                }}
                                            >
                                                • Inactiva
                                            </CBadge>
                                        )}
                                    </CTableDataCell>

                                    {/* MENÚ DESPLEGABLE NEUTRO PARA ACCIONES (ESTILO MEDUSA) */}
                                    <CTableDataCell className="pe-4 text-end">
                                        <CDropdown placement="bottom-end">
                                            <CDropdownToggle
                                                color="transparent"
                                                caret={false}
                                                className="btn-icon p-1 text-body-secondary border-0"
                                            >
                                                <CIcon icon={cilOptions} />
                                            </CDropdownToggle>

                                            <CDropdownMenu className="shadow-lg border-0 bg-body-tertiary p-1" style={{ minWidth: "160px" }}>
                                                <CDropdownItem className="d-flex align-items-center gap-2 rounded px-3 py-2 text-body small cursor-pointer">
                                                    <CIcon icon={cilPencil} size="sm" className="text-body-secondary" />
                                                    <span>Editar</span>
                                                </CDropdownItem>
                                                <CDropdownItem className="d-flex align-items-center gap-2 rounded px-3 py-2 text-danger small cursor-pointer">
                                                    <CIcon icon={cilTrash} size="sm" />
                                                    <span>Eliminar</span>
                                                </CDropdownItem>
                                            </CDropdownMenu>
                                        </CDropdown>
                                    </CTableDataCell>
                                </CTableRow>
                            ))}
                        </CTableBody>
                    </CTable>
                </CCardBody>
            </CCard>
            {/* Modal para Crear Categoría (Misma Lógica Original) */}
            <CModal visible={modalVisible} onClose={() => setModalVisible(false)}>
                <CModalHeader className="border-bottom border-secondary border-opacity-10">
                    <CModalTitle className="text-body fw-semibold fs-5">Crear Categoría</CModalTitle>
                </CModalHeader>
                <CModalBody className="p-4">
                    <div className="mb-3">
                        <CFormLabel className="text-body-secondary fw-medium small mb-2">
                            Nombre de la Categoría
                        </CFormLabel>
                        <CFormInput
                            placeholder="Ej. Bebidas Frías"
                            className="bg-body-secondary border-0 text-body py-2"
                        />
                    </div>
                </CModalBody>
                <CModalFooter className="border-top border-secondary border-opacity-10">
                    <CButton
                        color="transparent"
                        className="text-body-secondary bg-body-secondary border-0 px-3 py-2 cursor-pointer fw-medium"
                        onClick={() => setModalVisible(false)}
                    >
                        Cancelar
                    </CButton>
                    <CButton
                        className="border-0 text-white px-3 py-2 fw-medium cursor-pointer"
                        style={{ backgroundColor: '#FE2445', borderRadius: '6px' }}
                    >
                        Guardar
                    </CButton>
                </CModalFooter>
            </CModal>
        </div>
    );
};

export default CategoriesList;